// Added for the CPC
// This is a generic polyfill for
// web components
import './vendor/native-shim';
import sessionID from 'adc-session-id';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import Root from './containers/Core/Root';
import store from './store/index';
import { CpcProvider } from './hooks/useCpc';
import './styles/index.css';

require('./helpers/logger');

// Create a MAW session ID for following users across properties.
// We're doing this here because we want to start tracking asap.
sessionID();
// Persist wg param before React Router strips it from the URL
if (new URLSearchParams(window.location.search).get('wg') === 'true') {
  sessionStorage.setItem('wg', 'true');
}

const root = createRoot(document.getElementById('root'));

root.render(
  <Router basename="/">
    <CpcProvider>
      <Root store={store} />
    </CpcProvider>
  </Router>,
);
